import * as _ from "lodash"
import { INode } from "../PA.MD.Core/PA.MD.IF.Hierarchy"
import { HierarchyStructureClient } from "./HierarchyStructureClient"

export interface IHierarchyPathRow {
    [columnName: string]: string
}

export interface IHierarchyPathResults {
    rows: IHierarchyPathRow[]
    levelCount: number
}

const placeholderIdUI = '0'

/**
 * Flattens a hierarchy into L1..Ln path rows (one row per leaf), using the same
 * HierarchyStructureNavigator / HierarchyStructureClient that PA-HierarchyEditor's
 * Hierarchy Tree uses to render the interactive tree.
 */
export class HierarchyPathBuilder {

    // wbTargetWbId is the dimension-specific hierarchy id (WB_CUSTH_ID, WB_PRDH_ID, etc.), not the
    // generic WB_HIERARCHY_ID harness id - HierarchyStructureClient resolves between the two.
    static async getHierarchyPaths(entityDimension: string, wbTargetWbId: number, effectiveStartDt: Date, effectiveEndDt: Date): Promise<IHierarchyPathResults> {
        let hsn = await HierarchyStructureClient.getHierarchyNavigatorRangeByDimensionWbId(entityDimension, wbTargetWbId, effectiveStartDt, effectiveEndDt)
        if (_.isEmpty(hsn) || !hsn.bLoaded)
            return { rows: [], levelCount: 0 }

        let leafNodes = _.filter(hsn.getLeafNodesOfAnyLevel(), (n) => n.id_ui !== placeholderIdUI)

        let rows: IHierarchyPathRow[] = []
        let maxRank = 0

        _.forEach(leafNodes, (leaf) => {
            let chain: INode[] = []
            let visited: { [key: string]: boolean } = {}
            let n: INode = leaf
            while (!_.isEmpty(n) && n.id_ui !== placeholderIdUI) {
                let key = `${n.mapperName}_${n.wbId}`
                if (visited[key])
                    break // cycle guard
                visited[key] = true
                chain.unshift(n)
                n = hsn.getParent(n)
            }

            if (_.isEmpty(chain))
                return

            let row: IHierarchyPathRow = {}
            _.forEach(chain, (node, idx) => {
                let rank = idx + 1
                let level = hsn.getLevelByLevelDepth(hsn.getDepth(node))
                let levelName = level?.levelName
                if (_.isEmpty(levelName))
                    levelName = _.first(node.entityTypes)?.cif?.ENTITY_NAME || node.mapperName

                row[`L${rank}_ID`] = node.id_ui
                row[`L${rank}_NAME`] = node.node_name
                row[`L${rank}_TYPE`] = levelName
                maxRank = Math.max(maxRank, rank)
            })
            rows.push(row)
        })

        let sortKeys = _.map(_.range(1, maxRank + 1), (r) => `L${r}_NAME`)
        rows = _.sortBy(rows, sortKeys)

        return { rows, levelCount: maxRank }
    }
}
